module.exports = __webpack_public_path__ + "assets/img/65x_319_2.ca94e2a1.jpg";